import { render, staticRenderFns } from "./YoneticiTanimla.vue?vue&type=template&id=680c5ece&scoped=true&"
import script from "./YoneticiTanimla.vue?vue&type=script&lang=js&"
export * from "./YoneticiTanimla.vue?vue&type=script&lang=js&"
import style0 from "./YoneticiTanimla.vue?vue&type=style&index=0&id=680c5ece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680c5ece",
  null
  
)

export default component.exports